const map = new Map();

export default class StorageHelper {
  map = map;

  getStorage() {
    return this.map;
  }
}
